import * as React from 'react';
import classnames from '../../../_virtual/index.js';
import { useLink } from '@grandvisionhq/frk-routing';
import { Icon } from '@grandvisionhq/icons';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import { pushWishlistEvent } from '../../../data-layer/wishlist.js';
import { useGetShoppingListCount } from '../../../hooks/use-get-shopping-list-count.js';
import { useGetWishlistAriaLabel } from '../hooks/use-get-wishlist-aria-label.js';

const AnonymousWishlistMenuItem = ({ label , className , tabIndex  })=>{
    const { href  } = useLink({
        route: 'wishlist'
    }) || {};
    const { localWishlist , clearWishlist  } = useWishlistId();
    const { itemsCount  } = useGetShoppingListCount(localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id, clearWishlist);
    const count = itemsCount || 0;
    const ariaLabel = useGetWishlistAriaLabel(count);
    return /*#__PURE__*/ React.createElement("a", {
        className: classnames('wishlist-menu-item', className),
        href: href,
        title: label,
        tabIndex: tabIndex,
        "aria-label": tabIndex === -1 ? '' : ariaLabel,
        onClick: ()=>pushWishlistEvent({
                interactionType: 'wishlist_top_menu_click',
                siteFeature: 'wishlist_flow'
            })
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "favourite-empty"
    }), count > 0 && /*#__PURE__*/ React.createElement("span", {
        className: "wishlist-menu-item__counter"
    }, count));
};

export { AnonymousWishlistMenuItem as default };
//# sourceMappingURL=AnonymousWishlistMenuItem.js.map
